/**
 * Created by 1 on 2016/12/12.
 */
'use strict';
define([
    './CommonUtil',
    './GeometryUtil',
    '../layers/index',
    '../misc/AppEvents',
    '../g2',
], function (
    CommonUtil,
    GeometryUtil,
    lys,
    AppEvents,
    g2
) {
    /**
     * @namespace
     * @description 图层工具类，图层叠加、图层层级控制、图层获取等
     * @alias G.utils.LayerUtil
     */
        //
    var util = {};
    /**
     * 叠加底图（图层或者图层组）
     * @alias createBaseLayer
     * @memberof G.utils.LayerUtil
     * @param layerOpts {Object} 必填-图层配置
     * @param restHttp {Object} 选填-restHttp
     * @param map {Object} 选填-地图
     * @return {g2.lys.TileLayer}
     * @example
     * //单图层
     * var layerOpts={
        "id":"tiandituLayer_vec",//图层id
        "title":"天地图矢量",//图层名称
        //图层配置，参考tsgis api 中g2.lys. TileLayer说明
        "layers": "vec",
        "matrixSet": "c",
        "format": "tiles",
        "tileType": 102,
        "zIndex":-2,
        "url": "http://t0.tianditu.com/vec_c/wmts?",
        "projection":"EPSG:4326"
     }
     var baseLayer=G.utils.LayerUtil.createBaseLayer(layerOpts);
     * //图层组类型
     * var layerOpts={
                "id":"tiandituLayer_vec",
                "title":"天地图矢量",
                "type":"group",//图层组需要配置type=group
                "zIndex":-2,
                "layers":[
                    //图层配置，参考tsgis api 中g2.lys. TileLayer说明
                    {
                        "layers": "vec",
                        "matrixSet": "c",
                        "format": "tiles",
                        "tileType": 102,
                        "layerClass":"TileLayer",//图层类名，默认为TileLayer
                        "url": "http://t0.tianditu.com/vec_c/wmts?",
                        "projection":"EPSG:4326"
                    },
                    {
                        "layers": "cta",
                        "matrixSet": "c",
                        "format": "tiles",
                        "tileType": 102,
                        "layerClass":"TileLayer",//图层类名，默认为TileLayer
                        "url": "http://t0.tianditu.com/cta_c/wmts?",
                        "projection":"EPSG:4326"
                    }
                ]
            }
     var baseLayer=G.utils.LayerUtil.createBaseLayer(layerOpts);
     */
    util.createBaseLayer = function (layerOpts, restHttp, map) {
        if (!CommonUtil.isObject(layerOpts)) {
            throw (new Error('参数类型错误!'));
        }
        var layer = null;
        //需要支持图层组
        if (layerOpts.type == 'group') {
            let layers = layerOpts.layers,
                layerId = layerOpts.id || CommonUtil.newUUID();
            if (layerOpts.layerClass === "MBTileLayer") {
                let grouplayerList = [];
                for (let i = 0, len = layers.length; i < len; i++) {
                    let config = layers[i];
                    let lyr = createSingleLayer(config);
                    lyr._type = lys.TYPES.BASE_LAYER_TAG;
                    grouplayerList.push(lyr);
                }
                layer = grouplayerList;
                
            } else {
                let groupLayer = new g2.carto.GroupLayer({
                    id: layerId,
                    name: layerOpts.title || '',
                    zIndex: layerOpts.zIndex,
                    layers: []
                });
                for (var n = 0, len2 = layers.length; n < len2; n++) {
                    var config2 = layers[n];
                    var lyr2 = createSingleLayer(config2);
                    groupLayer.addLayer(lyr2);
                }
                layer = groupLayer;
            }
        } else {
            layer = createSingleLayer(layerOpts);
            layer.name = layerOpts.title || '';
        }
        /**
         * 标识图层为底图
         * @type {string}
         * @private
         */
        if (CommonUtil.isArray(layer)) {
            layer.forEach(l => {
                l._type = lys.TYPES.BASE_LAYER_TAG;
                l.layerGroups = layerOpts.layerGroups || '';
            })
        } else {
            layer._type = lys.TYPES.BASE_LAYER_TAG;
            layer.layerGroups = layerOpts.layerGroups || '';
        }
        
        return layer;
        
        function createSingleLayer(cfg) {
            if (restHttp) {
                cfg.restHttp = restHttp;
            }
            if (map){
                cfg.map = map;
            }
            let layerClass = cfg.layerClass || 'TileLayer';
            let layer = new g2.carto[layerClass](cfg);
            if (layerOpts.zIndex) {
                layer.setZIndex(layerOpts.zIndex);
            }
            return layer;
        }
    }
    
    /**
     * 获取底图图层
     * @ignore
     * @method
     * @param map {G.Map} -必填，地图对象
     * @returns {Array} 底图数组
     */
    util.getBaseLayer = function (map) {
        var g2map = map.getMap();
        var layers = g2map.layers,
            result = [];
        for (var i = 0, len = layers.length; i < len; i++) {
            var layer = layers[i];
            if (layer && layer._type == lys.TYPES.BASE_LAYER_TAG) {
                result.push(layer);
            }
        }
        return result;
    }
    
    /**
     * 移除底图图层
     * @ignore
     * @method
     * @param map {Object} - G.Map,必填，地图对象
     */
    util.removeBaseLayer = function (map) {
        var baseLayers = util.getBaseLayer(map),
            g2map = map.getMap();
        for (var i = 0, len = baseLayers.length; i < len; i++) {
            var layer = baseLayers[i];
            g2map.removeLayer(layer);
        }
        return baseLayers;
    }
    
    /**
     * 是否是底图
     * @ignore
     */
    util.isBaseLayer = function (layer) {
        return layer && layer._type === lys.TYPES.BASE_LAYER_TAG;
    }
    
    /**
     * 移除底图图层
     * @ignore
     * @method
     * @param map {G.Map} map对象
     * @param id 图层Id
     */
    util.removeBaseLayerById = function (map, id) {
        var layer = util.getLayerById(map, id);
        if (layer) {
            map.getMap().removeLayer(layer);
        }
    }
    
    /**
     * 清除图层元素
     * @ignore
     * @method
     * @param map {Object} -map对象
     * @param 图层名称
     */
    util.ClearLayerByName = function (map, layerName) {
        var layer = map.getMap().findLayer(layerName);
        if (layer) {
            layer.clear();
        }
    }
    
    /**
     * 清除图层元素
     * @ignore
     * @method
     * @param map {Object} map对象
     */
    util.ClearAllLayer = function (map) {
        for (var i = 0; i < map.getMap().layers.length; i++) {
            map.getMap().layers[i].clear();
        }
    }
    
    /**
     * 切换底图接口
     * @ignore
     * @method
     * @param opts {Object} 必填，底图配置对象
     * @param opts.map {G.Map} 必填，地图对象
     * @param opts.layerOpts {Object} 必填，切换的底图配置
     * @example
     * var layerOpts={
	            "id":"tiandituLayer_vec",
	            "title":"天地图矢量",
	            "type":"group",
	            "layers":[
	                //图层配置，参考tsgis api 中g2.lys. TileLayer说明
	                {
	                    "layers": "vec",
	                    "matrixSet": "c",
	                    "format": "tiles",
	                    "tileType": 102,
	                    //"url": "http://t0.tianditu.com/vec_c/wmts?",    //internet
	                    //"url": "http://172.17.10.180:11012/vec_c/wmts?",//gsafety-yf
	                    "url": "http://172.18.7.60/proxy/proxy/mapTiledProxy.ashx?http://t0.tianditu.cn/vec_c/wmts?", //gsafety-wuhan
	                    "projection":"EPSG:4326"
	                },
	                {
	                    "layers": "cta",
	                    "matrixSet": "c",
	                    "format": "tiles",
	                    "tileType": 102,
	                    //"url": "http://t0.tianditu.com/cta_c/wmts?",//internet
	                    //"url": "http://172.17.10.180:11012/cta_c/wmts?", //gsafety-yf
	                    "url": "http://172.18.7.60/proxy/proxy/mapTiledProxy.ashx?http://t0.tianditu.cn/cta_c/wmts?",//gsafety-wuhan
	                    "projection":"EPSG:4326"
	                }
	            ]
	        }
     let restHttp = new g2.core.RestHttp({
        client_id: "28524d8c65844630a3427270c9a16323",
        client_secret: "84bc17650bb04491aa8475b9cbe3d1c4"
    });
     
     var options={};
     options.map=map;
     options.layerOpts=layerOpts;
     options.restHttp = restHttp;
     var baseLayer=G.utils.LayerUtil.createBaseLayer(layerOpts);
     */
    util.switchBaseLayer = function (opts) {
        if (!(opts && opts.layerOpts)) {
            throw (new Error('参数类型错误！'));
        }
        var map = opts.map;
        //移除现有底图
        var oldBaseLayers = util.removeBaseLayer(map);
        //添加底图
        var newBaseLayers = [];
        let restHttp = opts.restHttp;
        if (CommonUtil.isArray(opts.layerOpts)) {
            for (var i = 0, len = opts.layerOpts.length; i < len; i++) {
                var layerOpt = opts.layerOpts[i];
                if (CommonUtil.isObject(layerOpt)) {
                    var newBaseLayer = util.createBaseLayer(layerOpt, restHttp);
                    map.addLayer(newBaseLayer);
                    newBaseLayers.push(newBaseLayer);
                }
            }
        } else {
            var newBaseLayer = util.createBaseLayer(opts.layerOpts, restHttp);
            map.addLayer(newBaseLayer);
            newBaseLayers.push(newBaseLayer);
        }
        //将其他图层zindex提升
        var layers = map.getLayers();
        for (var i = 0, len = layers.length; i < len; i++) {
            var lyr = layers[i];
            if (lyr._type === lys.TYPES.BASE_LAYER_TAG) {
                continue;
            }
            if (lyr.getZIndex() > 0) {
                continue;
            }
            lyr.setZIndex(1);
        }
        var event = {};
        //原来的底图
        event.old = oldBaseLayers;
        //新的底图
        event.new = newBaseLayers;
        map.fire(AppEvents.SWITCH_BASE_LAYER, event);
    }
    
    /**
     * 根据layerId获取图层对象
     * @alias getLayerById
     * @memberof G.utils.LayerUtil
     * @param map {g2.carto.Map} 必填，地图对象
     * @param layerId {String} 必填，图层id
     * @returns {g2.lys.Layer}
     */
    util.getLayerById = function (map, layerId) {
        if (layerId) {
            let g2map = null;
            if (map instanceof G.Map) {
                g2map = map.getMap()
            } else {
                g2map = map;
            }
            
            var layers = g2map.layers;
            var obj = {};
            for (var key in layers) {
                var layer = layers[key];
                getLayer(obj, layer, layerId);
                if (obj.layer) {}
            }
            return obj.layer || null;
        } else {
            return null;
        }
        
        function getLayer(obj, layer, layerId) {
            if (obj.layer) {
                return;
            }
            if (layer.id == layerId) {
                obj.layer = layer;
                return;
            } else if (layer instanceof g2.carto.GroupLayer) {
                var lys = layer.groupLayers;
                for (var k in lys) {
                    var lyr = lys[k];
                    getLayer(obj, lyr, layerId);
                }
            }
        }
    }
    
    /**
     *
     * @type {{point: number, polyline: number, polygon: number}}
     */
    var layerTypes = {
        'point': 1,
        'polyline': 2,
        'polygon': 3
    }
    
    /**
     *全局默认加载的点线面图层组
     * @type {Object}
     */
    var groupLayers = [{
        id: 'default-point-group',
        name: '点图层组'
    },
        {
            id: 'default-polyline-group',
            name: '线图层组'
        },
        {
            id: 'default-polygon-group',
            name: '面图层组'
        }
    ];
    
    //默认点线面图层组
    util.defaultGroupLayers = groupLayers;
    
    /**
     * 初始化默认的点线面图层组,
     * 用于解决点、线、面之间的遮盖关系
     * @alias initGroupLayers
     * @memberof G.utils.LayerUtil
     * @param map {G.Map} 必填，地图对象
     * @private
     */
    util.initGroupLayers = function (map, groupLayerZIndexes) {
        map._group_layer_indexes = groupLayerZIndexes || [12, 11, 10];
        const zIndexes = util.getGroupLayerZIndex(map);
        //判断是否初始化了点线面图层组
        if (!map._group_layer_initialized) {
            for (var i = 2; i >= 0; i--) {
                var l = groupLayers[i];
                var layer = new g2.carto.GroupLayer({
                    id: l.id,
                    name: l.name,
                    layers: [],
                    zIndex: zIndexes[i],
                });
                map.addLayer(layer);
            }
            map._group_layer_initialized = true;
        }
    }
    
    /**
     * 添加图层到图层组(emap默认加载的点线面图层组)
     * @alias addLayer2Group
     * @memberof G.utils.LayerUtil
     * @param map {G.Map} 必填，地图对象
     * @param layer {g2.lys.Layer} 必填，图层对象
     * @param layerType {String} 必填，图层点线面类型（点point,线polyline,面polygon)
     * @returns {boolean} - 返回true或False
     */
    util.addLayer2Group = function (map, layer, layerType) {
        var index = layerTypes[layerType] || 1;
        var layerCfg = groupLayers[index - 1];
        var groupLayer = util.getLayerById(map, layerCfg.id);
        const zIndexes = util.getGroupLayerZIndex(map);
        if (groupLayer) {
            groupLayer.addLayer(layer);
            layer.setZIndex(zIndexes[index-1]);
            //全局通知
            map.fire(AppEvents.LAYER_CHANGED, {
                type: 'add',
                layers: [layer]
            });
            return true;
        }
        return false;
    }
    
    /**
     * 从图层组(emap默认加载的点线面图层组)移除图层
     * @alias removeLayerFromGroup
     * @memberof G.utils.LayerUtil
     * @param map {G.Map} 必填，地图对象
     * @param layer {g2.lys.Layer} 必填，图层对象
     * @param layerType {String} 必填，图层点线面类型（点point,线polyline,面polygon)
     */
    util.removeLayerFromGroup = function (map, layer, layerType) {
        var index = layerTypes[layerType] || 1;
        var layerCfg = groupLayers[index - 1];
        var groupLayer = util.getLayerById(map, layerCfg.id);
        if (groupLayer) {
            groupLayer.removeLayer(layer);
            //全局通知
            map.fire(AppEvents.LAYER_CHANGED, {
                type: 'remove',
                layers: [layer]
            });
            return true;
        }
        return false;
    }
    
    // 图层组的zIndex
    util.getGroupLayerZIndex = function(map){
        return map._group_layer_indexes;
    }

    /**
     * 添加ImageLayer图层
     * @ignore
     * @method
     * @param opts {Object} 必填，参数对象
     * @param opts.map {G.Map} 必填，地图对象
     * @param opts.pointArr {Array} 必填，视野点数组，包含两个格式为{x:123,y:456}的坐标点数组
     * @param opts.url {Array} 必填，图层服务 url
     * @param opts.id {String} 必填，ImageLayer的id
     * @param opts.name {String} 必填，ImageLayer的name
     */
    util.addImageLayer = function (opts) {
        var imageLayer = new g2.carto.ImageLayer({
            id: opts.id,
            name: opts.name,
            imageType: 702,
            extent: [
                opts.pointArr[0].x,
                opts.pointArr[0].y,
                opts.pointArr[1].x,
                opts.pointArr[1].y
            ],
            crossOrigin: "anonymous", //跨域
            url: opts.url // 图层服务 url
        });
        
        // 将 图像图层添加到地图
        opts.map.addLayer(imageLayer);
    }
    
    /**
     * 清空地图上的image图层
     * @ignore
     * @method
     * @param map {G.Map}地图对象
     * @param id {String}清除的layer id
     */
    util.clearImageLayer = function (map, id) {
        if (map.findLayer(id)) {
            map.getMap().removeLayer(map.findLayer(id));
        }
    }
    
    /**
     * 添加元素图层
     * @ignore
     * @method
     * @deprecated
     * @param options.id 图层id
     * @param options.name 图层名称
     * @param options.map 必填 图层所依赖的地图
     * @param options.geoInfo 必填 绘制图形的wkt字符串
     * @param options.symbol 必填 绘制图形的样式
     * @param options.symbol  绘制图形的其他信息
     */
    util.addElementLayer = function (options) {
        var elementLayer;
        if (options.map.findLayer(options.name) == null) {
            elementLayer = new g2.carto.ElementLayer({map: options.map.getMap(), name: options.name, id: options.id});
            //修改图层问题
            options.map.getMap().addLayer(elementLayer);
        } else {
            elementLayer = options.map.findLayer(options.name);
        }
        var element = G.utils.RenderUtil.geoinfoToElement(options.geoInfo, options.symbol, options.eleInfo);
        elementLayer.add(element);
    }
    
    /**
     * 获取图层范围
     * @ignore
     * @method
     * @param layer {g2.lys.ElementLayer/G.lys.BaseLayer/g2.lys.FeatureLayer} 必填 图层对象
     * @returns {g2.sfs.Geometry}
     */
    util.getLayerExtent = function (layer) {
        if (layer instanceof lys.BaseLayer) {
            layer = layer.getLayer();
        }
        var geomArr = fetchGeom(layer);
        return GeometryUtil.getGeometryEnvlop(geomArr);
        
        //
        function fetchGeom(layer) {
            var arr = [],
                geomArr = [];
            if (layer instanceof g2.carto.FeatureLayer) {
                arr = layer.features;
            } else if (layer instanceof g2.carto.ElementLayer) {
                arr = layer.elements;
            } else if (layer instanceof g2.carto.ClusterLayer) {
                arr = layer.elements;
            } else if (layer instanceof g2.carto.GroupLayer) {
                var lys = layer.groupLayers;
                for (var l in lys) {
                    var ly = lys[l];
                    var lyArr = fetchGeom(ly) || [];
                    geomArr = geomArr.concat(lyArr);
                }
                return geomArr;
            } else {
                throw (new Error('图层类型错误！'))
            }
            for (var k in arr) {
                var el = arr[k];
                if (el && el.geometry) {
                    geomArr.push(el.geometry);
                }
            }
            return geomArr;
        }
    }
    
    /**
     * 设置图层指定类型的样式
     * @ignore
     * @method
     * @param map 必填 图层所依赖的地图
     * @param layer {g2.lys.ElementLayer/g2.lys.FeatureLayer} 必填 图层对象
     * @param symbolArr {Array} - 必填，指定的符号样式数组；注：symbol格式对应G.utils.RenderUtil.geoinfoToElement中的symbol参数
     */
    util.setLayerSymbol = function (map, layer, symbolArr) {
        if (!layer && symbolArr.length == 0) {
            throw (new Error('参数类型错误！'))
        }
        if (CommonUtil.isEmptyObject(layer.symbol)) {
            layer.symbol = {};
        }
        var symbolTypeObj = {
            "TextSymbol": "TextSymbol",
            "SimpleMarkerSymbol": "SimpleMarkerSymbol",
            "PictureMarkerSymbol": "PicturemarkerSymbol",
            "SimpleLineSymbol": "SimpleLineSymbol",
            "SimpleFillSymbol": "SimpleFillSymbol"
        }
        if (layer instanceof g2.carto.GroupLayer) {
            //解析grouplayer暂时只支持图层管理的有规则的图层组
            var layerGroupId = layer.id.substr(0, layer.id.length - 12);
            var elementLayer = util.getLayerById(map, layerGroupId + 'elementLayer');
            render(elementLayer);
            var featureLayer = util.getLayerById(map, layerGroupId + 'featureLayer');
            render(featureLayer);
        } else {
            render(layer);
        }
        
        function render(renderLayer) {
            //设置element图层样式
            if (renderLayer instanceof g2.carto.ElementLayer) {
                for (var i = 0; i < symbolArr.length; i++) {
                    renderLayer.symbol[symbolArr[i].type] = symbolArr[i].options;
                    var eleArr = renderLayer.elements;
                    var symbolType = symbolTypeObj[symbolArr[i].type];
                    if (eleArr.length > 0) {
                        for (var j = 0; j < eleArr.length; j++) {
                            var newSymbol = new g2.sfs[symbolType](symbolArr[i].options);
                            if (newSymbol.$type == eleArr[j].symbol.$type) {
                                eleArr[j].symbol = newSymbol;
                                renderLayer.update(eleArr[j], true);
                            }
                        }
                    }
                }
            } else {
                //设置feature图层样式
                var symbolType = symbolTypeObj[symbolArr[0].type];
                var newSymbol = new g2.sfs[symbolType](symbolArr[0].options)
                var sim = new g2.render.SimpleRenderer({symbol: newSymbol});
                renderLayer.featureRenders.length = 0;
                renderLayer.render(sim);
            }
        }
    }
    
    /**
     * 获取图层指定类型的样式
     * @ignore
     * @method
     * @param layer {g2.lys.ElementLayer/g2.lys.FeatureLayer} 必填 图层对象
     * @param type {String} 必填，获取样式的类型
     * @return symbol {Object} 返回获取的样式 注：格式对应G.utils.RenderUtil.geoinfoToElement中的symbol参数
     */
    util.getLayerSymbol = function (layer, type) {
        if (!layer && !type) {
            throw (new Error('参数类型错误！'))
        }
        var symbol = {};
        if (CommonUtil.isEmptyObject(layer.symbol)) {
            symbol = {};
        } else {
            symbol.type = type;
            symbol.options = layer.symbol[type];
        }
        return symbol;
    }
    var geometryType = {
        "Point": "POINT",
        "Polyline": "LINESTRING",
        "Polygon": "POLYGON"
    }
    
    /**
     * 选择元素
     * @ignore
     * @method
     * @param geometry {g2.lys.ElementLayer} 必填，传入坐标集合 注：g2.sfs.Geometry or Wkt or GeoJSON,geometry对象
     * @param layers {Array} 必填，需要对比的图层，图层类型： g2.lys.ElementLayer/g2.lys.FeatureLayer/g2.lys.GroupLayer/G.lys.DistributeLayer
     * @param topologicalType {String} 选填，拓扑类型 例：contains(包含)，intersects(相交)
     * @return obj {Object} 选中的点集合
     */
    util.selectElementOnMap = function (geometry, layers, topologicalType) {
        if (!geometry || layers.length == 0) {
            throw new Error("传入参数错误");
        }
        if (!topologicalType) {
            topologicalType = 'intersects';
        }
        //把框的元素转换成jsts的元素
        var selectPolygon = G.utils.GeometryUtil.toJstsGeometry(geometry);
        //循环传入的图层的元素
        var obj = {};
        for (var j = 0; j < layers.length; j++) {
            var layer = layers[j];
            var layerId = layer.getLayerId();
            //支持一张图图层
            if (layer instanceof lys.DistributeLayer) {
                layer = layer.getLayer();
            }
            obj[layerId] = selectLayerElements(layer, selectPolygon, topologicalType);
        }
        return obj;
        
        /**
         * 图层上选择元素
         * @param layer
         * @param filter
         * @param relation
         */
        function selectLayerElements(layer, filter, relation) {
            var eles = [];
            if (layer instanceof g2.carto.ElementLayer ||
                layer instanceof g2.carto.FeatureLayer) {
                var count = layer.getCount();
                //循环查找地图上的元素
                for (var p = 0; p < count; p++) {
                    var ele = layer.get(p);
                    var jstsEle = G.utils.GeometryUtil.toJstsGeometry(getGeometry(ele));
                    var jstsInter = filter[relation](jstsEle);
                    if (jstsInter) {
                        eles.push(ele);
                    }
                }
            } else if (layer instanceof g2.carto.GroupLayer) {
                var layers = layer.groupLayers;
                for (var i = 0, len = layers.length; i < len; i++) {
                    var lyr = layers[i];
                    eles = eles.concat(selectLayerElements(lyr, filter, relation));
                }
                
            }
            return eles;
        }
        
        /**
         * 获取坐标
         * @param ele
         * @returns {*}
         */
        function getGeometry(ele) {
            if (ele instanceof g2.sfs.PlotElement) {
                var elements = ele.elements;
                var element = elements[elements.length - 1];
                return element.geometry;
            } else {
                return ele.geometry;
            }
        }
    }
    
    /**
     * 添加图层
     * @ignore
     * @param options.name 图层名称
     * @param options.id 图层id
     * @param options.zIndex 图层显示等级
     * @param options.attr 图层所属
     * @param options.visible 图层是否可见
     * @param options.groupType 所属图层组 point line polygon
     * @param map
     * @returns {elementLayer}
     */
    util.addElementLayerToMap = function (options, map) {
        var elementLayer = new g2.carto.ElementLayer({
            map: map,
            name: options.name,
            id: options.id,
            zIndex: options.zIndex,
            attr: options.attr,
            visible: options.visible,
            groupType: options.groupType
        });
        elementLayer.attr = options.attr;
        if (options.groupType == "point" || options.groupType == "line" || options.groupType == "polygon") {
            util.addLayer2Group(map, elementLayer, options.groupType);
        } else {
            map.addLayer(elementLayer);
        }
        return elementLayer;
    }
    return util;
});